import _ from "lodash";
import React from "react";
import Icon from "../../shared/Icon";
import ObSummary from "../ObSummary";
import "./ObSurveil.scss";
import DilatationMeter from "./ObSurveilPatient/DilatationMeter";
import {
  getObPatientName,
  ObPatientLocation,
  ObPatientStatus,
} from "./ObSurveilPatient/ObPatientInfo";
import { observer } from "mobx-react";
import ErrorBoundary from "../../shared/ErrorBoundary";

const ObSelectedPatient = ({ parent, store }) => {
  {
    return (
      <div className="selected-patient">
        <header>
          <Icon
            className="close"
            symbol="x"
            onClick={() => (store.selectedPatient = null)}
          />
          <DilatationMeter
            dilatation={store.moduleSpecifics(store.selectedPatient).dilatation}
          />
          <div className="patient-info">
            <div className="top">
              <div className="name">
                {getObPatientName(store.showPHI, store.selectedPatient)}
              </div>
              <span> • </span>
              <div className="age">{store.selectedPatient.age}</div>
            </div>
            <div className="location">
              <ObPatientLocation
                mrn={
                  (_.get(store.prefs, "userPreferences.client.pm.showPHI") ===
                  false
                    ? null
                    : store.selectedPatient.mrn) || "--"
                }
                unit={store.moduleSpecifics(store.selectedPatient).unit}
                bed={store.moduleSpecifics(store.selectedPatient).location}
              />
            </div>
            <div className="status">
              <ObPatientStatus
                specifics={store.moduleSpecifics(store.selectedPatient)}
              />
            </div>
          </div>
        </header>
        <ErrorBoundary>
          <ObSummary
            key={store.selectedPatient.asmpid}
            {...parent.props}
            patient={store.selectedPatient}
            moduleSpecifics={store.moduleSpecifics(store.selectedPatient)}
            isObSurveil={true}
          />
        </ErrorBoundary>
      </div>
    );
  }
};

export default observer(ObSelectedPatient);
